import { useState } from 'react'
import { PricingPlans } from '../Pricing/usePricing'

export interface HeroProps {}

export const useHero = (props: HeroProps) => {
  const [showModal, setShowModal] = useState(false)
  const [selectedPlan, setSelectedPlan] = useState<PricingPlans>(
    PricingPlans.FreePlan
  )

  const handleStartClick = () => {
    setShowModal(true)
    handlePlanChange(PricingPlans.FreePlan)
  }

  const handlePlanChange = (plan: PricingPlans) => {
    setSelectedPlan(plan)
  }

  return {
    ...props,
    showModal,
    selectedPlan,
    setShowModal,
    handleStartClick,
    handlePlanChange,
  }
}
